import { VehicleType } from "@/api-schema-enums";
import { VEHICLE_TYPE_LABELS } from "@/common/helpers/vehicle-type-labels";
import i18next from "i18next";
import { BaseFilterProps, Filter, FilterData } from "../_types";
import { FilterComponent } from "../base-filter";

function getVehicleTypeOptions(): { id: VehicleType; name: string }[] {
  const lang = i18next.language === "de" ? "de" : "en";
  return Object.entries(VEHICLE_TYPE_LABELS)
    .filter(([key]) => Object.values(VehicleType).includes(key as VehicleType))
    .map(([id, labels]) => ({ id: id as VehicleType, name: labels[lang] }));
}

export class VehicleTypeFilter extends Filter<Record<string, never>, Record<string, never>> {
  readonly id: string = "vehicleType";
  readonly labelSingular = "masterdata:VehicleType";
  readonly labelPlural = "masterdata:VehicleType";
  readonly placeholder = "masterdata:SelectVehicleType";
  readonly searchPlaceholder = "masterdata:SearchVehicleType";
  readonly emptyText = "masterdata:NoVehicleTypeFound";
  body = {};
  parameters = {};

  constructor({ id }: { id?: string } = {}) {
    super();
    if (id) this.id = id;
  }

  getData(): FilterData {
    return {
      options: getVehicleTypeOptions(),
      isLoading: false,
      error: null,
    };
  }

  render(props: BaseFilterProps) {
    return <FilterComponent filter={this} {...props} />;
  }
}
